export default "__VITE_ASSET__RE6vsMgq__"